var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editorId",staticClass:"abc"}),_c('div',{staticClass:"text-center"},[(!_vm.viewMode && !_vm.hideSaveButton)?_c('button',{staticClass:"btn btn-success mr-xs mt-5 mb-2",attrs:{"type":"button"},on:{"click":_vm.getOutput}},[_vm._v("Save")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }